import { Component, OnInit } from '@angular/core';
import { PopoverController } from '@ionic/angular';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthenticationService } from '../../_services';
import { CommonService } from '../../_services/common.service';

@Component({
  selector: 'help-message',
  templateUrl: './help-message.component.html',
  styleUrls: ['./help-message.component.scss'],
})
export class HelpMessageComponent implements OnInit {
  companyTel = '';
  isWahl : boolean = false;
  constructor(
    public activeModal: NgbActiveModal,
    private authService: AuthenticationService,
    private commonService: CommonService
  ) { }

  ngOnInit() {
    const appSettingsData = this.authService.appSettingsData;
    if (appSettingsData) {
      this.companyTel = appSettingsData && appSettingsData.data && appSettingsData.data.settings && appSettingsData.data.settings.app_settings && appSettingsData.data.settings.app_settings
          && appSettingsData.data.settings.app_settings &&  appSettingsData.data.settings.app_settings.setting_data && appSettingsData.data.settings.app_settings.setting_data.misscall;
    }
    if(this.authService.currentUserValue.loginData.user.sellerCode === 'WAHL'){
      this.isWahl =true;
    }
  }

  close() {
    this.activeModal.dismiss();
  }

  openUrl(url) {
    this.commonService.openInNewWindow(url, false, () => {});
  }

}
